import throttle from 'lodash.throttle';
import { offset, scrollTop } from '@/utils/dom';

// a reference to add/remove event listeners
let scrollHandler;

export default {
  bind(el) {
    scrollHandler = throttle(stickIt.bind(null, el, offset, scrollTop), 250);
    window.addEventListener('scroll', scrollHandler);
    /* istanbul ignore next */
    // for testing purposes
    return scrollHandler;
  },

  unbind() {
    window.removeEventListener('scroll', scrollHandler);
  },
};

/* eslint-disable no-shadow */
export function stickIt(el, offset, scrollTop) {
  const stickyTarget = document.querySelector(el.dataset.stickyTarget);
  if (!stickyTarget) return;
  const stickyTop = offset(el).top;
  const topOffset = parseInt(el.dataset.stickyTopOffset, 10);
  const { stickyClass } = el.dataset;

  if (scrollTop(window) > stickyTop - topOffset) {
    stickyTarget.classList.add(stickyClass);
  } else {
    stickyTarget.classList.remove(stickyClass);
  }
}
